import { Reveal } from "./Reveal";
import { cn } from "@/lib/utils";

interface Props {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  className?: string;
}

export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  className,
}: Props) {
  return (
    <Reveal y={24} duration={0.7}
      className={cn(
        "mx-auto max-w-3xl",
        align === "center" ? "text-center" : "text-left",
        className,
      )}
    >
      {eyebrow && (
        <p className="mb-4 text-[11px] uppercase tracking-[0.32em] text-gold">
          {eyebrow}
        </p>
      )}
      <h2 className="text-balance text-3xl leading-[1.15] text-ivory md:text-5xl">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-5 text-pretty text-base leading-relaxed text-slate-muted md:text-lg">
          {subtitle}
        </p>
      )}
    </Reveal>
  );
}
